import { render, staticRenderFns } from "./callback.pug?vue&type=template&id=4960d1bc&lang=pug&external"
import script from "./callback.js?vue&type=script&lang=js&external"
export * from "./callback.js?vue&type=script&lang=js&external"
import style0 from "./callback.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4960d1bc')) {
      api.createRecord('4960d1bc', component.options)
    } else {
      api.reload('4960d1bc', component.options)
    }
    module.hot.accept("./callback.pug?vue&type=template&id=4960d1bc&lang=pug&external", function () {
      api.rerender('4960d1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/callback/index.vue"
export default component.exports